import { jsx as r } from "react/jsx-runtime";
import { tv as m } from "tailwind-variants";
import { I as f } from "./chunks/index-CK5eTiKX.js";
const l = {
  xs: 32,
  sm: 40,
  md: 50,
  lg: 80,
  xl: 180,
  profile: 240
}, w = m({
  slots: {
    wrapper: [
      "bg-white",
      "flex-shrink-0",
      "rounded-full",
      "relative",
      "shadow-inner",
      "before:absolute",
      "before:h-full",
      "before:left-0",
      "before:rounded-full",
      "before:shadow-[inset_-1px_1px_3px_rgba(0,0,0,0.2)]",
      "before:top-0",
      "before:w-full"
    ],
    image: [
      "aspect-square",
      "h-full",
      "object-cover",
      "rounded-full",
      "w-full"
    ]
  },
  variants: {
    size: {
      xs: { wrapper: ["w-[2rem]"] },
      sm: { wrapper: ["w-[2.5rem]"] },
      md: { wrapper: ["w-[3.125rem]"] },
      lg: { wrapper: ["w-[5rem]"] },
      xl: { wrapper: ["w-[10rem]"] },
      profile: { wrapper: ["max-w-[15rem]", "w-full"] }
    }
  }
}), n = ({ className: a, image: o, size: e = "md", title: s }) => {
  const { wrapper: p, image: t } = w({ size: e });
  return /* @__PURE__ */ r("div", { className: p({ class: a }), children: /* @__PURE__ */ r(
    f,
    {
      alt: "",
      className: t(),
      height: l[e],
      src: o,
      title: s,
      width: l[e]
    }
  ) });
};
export {
  n as default
};
